<template lang="pug">
.z-100.auto-alpha-0(:class="[isEditModeActive ? 'auto-alpha-1' : '']")
  label.absolute.top-12.right-5.py-4.px-4.inline-block.dark_text-white.select-none.rounded-full.flex.items-center.gap-3.group.drop-shadow-md(
    class="dark_bg-black/70 bg-white/70"
    ref="elRef"
    v-if="props.type === 'section'"
  )
    button.fancy-hover.mx-auto.flex.justify-center.items-center(@click="confirmDelete" class="uc-tiptap-edit-icon")
      uc-icon.absolute.text-2xl.font-bold.rounded-full(icon="mdi:trash-can" class="delete-page-icon")

  uc-lightbox.lightbox-confirm-delete.sm_p-4.primary-indigo(:locked="false" :id="deleteLightboxId(id)")
    .text-left.flex.flex-col.gap-2.max-w-prose.prose-stack.prose
      h2.m-0.mb-4.text-3xl.font-light.inline-flex.items-center.gap-2
        uc-text(text="Delete page")
      p.m-0
        uc-text(text="You are about to delete the page. Once it is deleted it cannot be restored.")
      p.m-0.font-bold
        uc-text(text="Are you sure you want to delete the page?")
      .flex.justify-end.gap-4.mt-4
        button.btn.btn-secondary.hover_bg-gray-400(@click="closeLightbox")
          uc-text(text="Keep page")
        button.btn.bg-red-800.text-white(@click="deleteSection")
          uc-text(text="Delete page")

</template>

<script setup lang="ts">
import { computed, inject, ref, unref, watch, watchEffect } from 'vue';
import useContent from '../stores/useContent';
import { setCompleted } from '../lib/SCORM';
import openLightbox, { closeLightbox } from '../lib/openLightbox';

const currentLocation = unref(inject('currentLocation'));
const isEditModeActive = inject('isEditModeActive') as Ref<boolean>;
const props = defineProps<{
  screen: UcScreen;
  unit: Page;
  type: string;
  id: string;
}>();
const content = useContent();
const findAdvancedPatchScreenById = useContent().findAdvancedPatchScreenById;
const included = ref(!content.compiled.hidden?.[props.id]);
const elRef = ref<HTMLElement>();
const page = document.querySelector('.page') as HTMLElement;

const currentPageIsActive = computed(() => {
  return props.id === currentLocation;
});

const deleteLightboxId = (name: string) => `lightbox_delete_${props.id}`;

const confirmDelete = () => {
  openLightbox(deleteLightboxId(props.id));
};

const deleteSection = () => {
  closeLightbox();
  const advancedPatchScreen = findAdvancedPatchScreenById(props.id);

  if (!advancedPatchScreen) return;
  if (!/(<|>)\s[#]/.test(advancedPatchScreen.key)) {
    console.error(
      'Delete patch: path not an advanced patch',
      advancedPatchScreen.key
    );
    return;
  }

  content.deleteAdvancedPatch(advancedPatchScreen.key);

  const el = elRef.value as HTMLElement;
  page
    .refreshSections()
    .then(() => el.closest('.scroller')?.scrollOne('prev', { force: true }));
};
</script>
<style>
.lightbox-confirm-delete .self-end {
  display: none;
}

.delete-page-icon {
  color: rgb(29 78 216 / var(--tw-bg-opacity)) !important;
}
</style>
